const Spinner = () => {
  return (
    <div className="position-absolute start-50">
      <span className="text-primary font-size-24">
        <i className="bx bx-loader bx-spin align-middle me-2" />
        {/* Loading */}
      </span>
    </div>
  );
};

export default Spinner;
